/*
 * @Author: liuyongjun
 * @Date: 2023-10-19 11:36:03
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-01-23 13:25:31
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/store/module/user.js
 */

const user = {
  state: {
    userInfoObj: {},
    seatId: '',
    isDutyDone: null,
    code: '',
    yearReportObj: {},
    menuList: [],
    userName: '',
    isIos: ''
  },

  mutations: {
    SET_USERINFO: (state, userInfoObj) => {
      state.userInfoObj = userInfoObj
      state.userName = userInfoObj.user.userName
    },
    SET_YEAR_REPORT: (state, yearReportObj) => {
      state.yearReportObj = yearReportObj
    },
    SET_SEAT_ID: (state, seatId) => {
      state.seatId = seatId
    },
    SET_IS_DUTY_DONE: (state, isDutyDone) => {
      state.isDutyDone = isDutyDone
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_MENULIST: (state, menuList) => {
      state.menuList = menuList
    },
    SET_SYSTEM_TYPE: (state, result) => {
      state.isIos = result
    }
  },

  actions: {
    setUserInfo({ commit }, res) {
      commit('SET_USERINFO', res)
    },
    setYearReport({ commit }, res) {
      commit('SET_YEAR_REPORT', res)
    },
    setSeatId({ commit }, seatId) {
      commit('SET_SEAT_ID', seatId)
    },
    setIsDutyDone({ commit }, isDutyDone) {
      commit('SET_IS_DUTY_DONE', isDutyDone)
    },
    setCode({ commit }, code) {
      commit('SET_CODE', code)
    },
    setMenuList({ commit }, menuList) {
      commit('SET_MENULIST', menuList)
    },
     setIsIos({ commit }, result) {
      commit('SET_SYSTEM_TYPE', result)
    },
  }
}

export default user
